import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Fields, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { Button, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  scrollToFirstError,
  InputFieldBlock,
  DateFieldBlock,
} from 'ecs-react-components/dist/index.es';
import { messages } from './LinkUserLoginForm.i18n';
import Header from '../../components/Header/Header';

import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';

export const fields = ['lastName', 'day', 'month', 'year'];

class LinkUserLoginForm extends Component {
  onSubmit = (values) => {
    this.props.handleLogin(values);
  };

  onFormChange = () => {
    this.props.dispatch(MsgBarActions.dismissMessage());
  };

  renderFields = (fieldsMeta) => {
    const { lastName, day, month, year } = fieldsMeta;
    if (this.props.languageCode) {
      moment.locale(this.props.languageCode.toLowerCase());
    }
    const dateFormat = moment.localeData().longDateFormat('l');

    return (
      <div>
        <InputFieldBlock
          id="lastName"
          key="lastName"
          labelText={ <FormattedMessage { ...messages.lastName } /> }
          field={lastName}
          rowClass="mb-3"
        />
        <DateFieldBlock
          id="dateOfBirth"
          key="dateOfBirth"
          labelText={ <FormattedMessage { ...messages.dateOfBirth } />}
          dayField={day}
          monthField={month}
          yearField={year}
          dateFormat={dateFormat}
          rowClass="mb-3"
        />
      </div>
    );
  }

  render() {
    const { handleSubmit, facilityPortalName } = this.props;
    return (
      <div className="row justify-content-md-center mt-3">
        <Col md={8} xl={6}>
          <Header
            headerTitle={facilityPortalName}
            hasLanguageDropdown
          />
          <div className="card p-3">
            <div className="card-body">
              <h2 tabIndex="0">
                <FormattedMessage {...messages.login.label} />
              </h2>
              <form onSubmit={handleSubmit(this.onSubmit)}
                onChange={this.onFormChange}
              >
                <Fields names={fields} component={this.renderFields} />
                <Button className="btn btn-primary" type="submit" aria-describedby="button_description">
                  <FormattedMessage {...messages.login.label} />
                </Button>
              </form>
            </div>
          </div>
        </Col>
      </div>
    );
  }
}

LinkUserLoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleLogin: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  facilityPortalName: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  submitFailed: PropTypes.bool,
  dispatch: PropTypes.func,
  languageCode: PropTypes.string,
};

const reduxFormConfig = {
  form: 'linkUserLoginForm',
  enableReinitialize: true,
  onSubmitFail: (errors) => scrollToFirstError(errors, fields),
  fields,
};

const mapStateToProps = (state) => ({
  facilityPortalName: state.facility ? state.facility.facilityPortalName : null,
  languageCode: state.language.languageCode,
});


export default reduxForm(reduxFormConfig)(connect(mapStateToProps)(LinkUserLoginForm));
